const hexToPantone = {
    "#EF5725": "RED ORANGE 17-1464 TCX",
    "#F12830": "FIERY RED 18-1664 TCX",
    "#D4202B": "CHILI PEPPER 19-1557 TPX",
    "#B43296": "ROSE VIOLET 17-2624 TCX",
    "#F055A1": "CARMINE ROSE 17-2230 TCX",
    "#F690BC": "PINK DRINK 14-2216 TCX",
    "#85471F": "TOBACCO BROWN 17-1327",
    "#FFDAAB": "MACADAMIA 12-0709 TCX",
    "#008E99": "LAKE BLUE 17-4928 TCX",
    "#019249": "FERN GREEN 17-6153",
    "#9CCC3C": "CLASSIC GREEN 16-6340",
    "#4B5320": "CHIVE 19-0323 TCX",
    "#F2EC5C": "YELLOW JASPER 12-0719 TCX",
    "#FFF002": "EMPIRE YELLOW 14-0756 TXC",
    "#F67420": "ORANGE OCHRE 16-1253",
    "#CC5500": "MARMALADE 17-1140 TCX",
    "#FFFFFF": "BRIGHT WHITE 11-0601 TPX",
    "#8F9396": "ULTIMATE GREY 17-5104 TCX",
    "#5E5E5E": "WILD DOVE 17-1501",
    "#221E1F": "BLACK-6 C",
    "#4E2575": "TILLANDSIA PURPLE 19-3638 TCX",
    "#6E3B97": "PURPLE SAPHIRE 18-3540 TCX",
    "#5A47A1": "ULTRA VIOLET 18-3838",
    "#003087": "NAVY BLUE 19-3832 TCX",
    "#2271BE": "FRENCH BLUE 18-4140 TCX",
    "#03A4F5": "BONNIE BLUE 16-4134 TCX",
    "#FFFFFF": "WHITE",
    "#000000": "BLACK"
};

function getColorChanges(svgElement) {
    const seen = new Set();
    const changes = [
  "Selected Colors:",
  "=================",
  "Original color           Replaced color",
  ""
];
    const hexRegex = /^#[0-9A-F]{6}$/i;

    // Convierte nombres de color como 'white' a #FFFFFF
    function toHex(color) {
        if (!color) return null;

        if (color.startsWith("rgb")) {
            const rgb = color.match(/\d+/g);
            if (rgb) {
                return "#" + rgb.slice(0, 3).map(x => (+x).toString(16).padStart(2, "0")).join("").toUpperCase();
            }
        }

        if (color.startsWith("#")) return color.toUpperCase();

        // Convertir nombres de color a HEX usando canvas
        const ctx = document.createElement("canvas").getContext("2d");
        ctx.fillStyle = color;
        const computed = ctx.fillStyle;

        if (computed.startsWith("rgb")) {
            const rgb = computed.match(/\d+/g);
            if (rgb) {
                return "#" + rgb.slice(0, 3).map(x => (+x).toString(16).padStart(2, "0")).join("").toUpperCase();
            }
        }

        return computed.toUpperCase();
    }

    svgElement.querySelectorAll("[data-original-color]").forEach(el => {
        let original = toHex(el.dataset.originalColor);
        let current = el.getAttribute("fill");

        if (!current || current === "none") {
            current = getComputedStyle(el).fill;
        }

        current = toHex(current);

        if (!hexRegex.test(original) || !hexRegex.test(current)) return;

        // Crear clave única para evitar duplicados
        const entryKey = `${original} --> ${current}`;
        if (!seen.has(entryKey)) {
            seen.add(entryKey);
            const pantoneName = hexToPantone[current] || "CUSTOM COLOR";
            //changes.push(`${original} --> ${current}  ---> ${pantoneName}`);
            // Replace HEX to pantones:
            const originalPantone = hexToPantone[original] || original;
            const currentPantone = hexToPantone[current] || current;
            changes.push(`${originalPantone}           ======> ${currentPantone}`);
        }
    });

    return changes.join("\n");
}


document.addEventListener("DOMContentLoaded", function() {
    var selectBaseButton = document.getElementById("selectBaseButton");
 
        function showLoading() {
          let loader = document.createElement("div");
          loader.id = "loading-overlay";
          loader.style.position = "fixed";
          loader.style.top = "0";
          loader.style.left = "0";
          loader.style.width = "100vw";
          loader.style.height = "100vh";
          loader.style.background = "rgba(0, 0, 0, 0.8)";
          loader.style.display = "flex";
          loader.style.alignItems = "center";
          loader.style.justifyContent = "center";
          loader.style.zIndex = "9999"; 
          const loadingImage = document.createElement("img");
          loadingImage.src = "https://cdn.shopify.com/s/files/1/0651/6169/1366/files/loader_cstm.gif";
          loadingImage.alt = "Uploading...";
          loadingImage.style.width = "284px"; 
          loader.appendChild(loadingImage);
          document.body.appendChild(loader);
      }

  
      
      function hideLoading() {
          let loader = document.getElementById("loading-overlay");
          if (loader) {
              document.body.removeChild(loader);
          }
      }


    if (selectBaseButton) {
        selectBaseButton.addEventListener("click", async function() {
            try {
                showLoading();

                // 🔹 Obtener el SVG editado desde la página
                let svgElement = document.getElementById("svg-container").querySelector("svg");
                if (!svgElement) {
                    throw new Error("❌ No SVG element found.");
                }

                function detectOriginalColorsFromAttributes(svgElement) {
                    svgElement.querySelectorAll("*").forEach(el => {
                        if (!el.hasAttribute("data-original-color") && el.hasAttribute("fill")) {
                        const fill = el.getAttribute("fill").trim();
                        if (fill && fill !== "none" && fill !== "transparent" && /^#[0-9A-Fa-f]{6}$/.test(fill)) {
                            el.setAttribute("data-original-color", fill.toUpperCase());
                        }
                        }
                    });
                }

                let colorChangeText = getColorChanges(svgElement);

                // 🔹 Convertir SVG a string
                let svgData = new XMLSerializer().serializeToString(svgElement);

                // 🔹 Guardar el SVG en localStorage antes de enviarlo
                localStorage.setItem("customImageSVG", svgData);

                console.log("📤 Preparando imagen SVG para enviar...");

                // 🔹 Crear un archivo Blob del SVG
                let svgBlob = new Blob([svgData], { type: "image/svg+xml" });
                let txtBlob = new Blob([colorChangeText], { type: "text/plain" });

                // 🔹 Usar FormData para enviar el archivo al servidor
                let formData = new FormData();
                formData.append("image", svgBlob, "custom_image.svg");
                formData.append("color_changes", txtBlob, "custom_image_colors.txt");


                console.log("📤 Enviando la imagen SVG al servidor...");

                let response = await fetch("https://diy.mostlyheardrarelyseen8bit.com/upload.php", {
                    method: "POST",
                    body: formData
                });

                console.log("📥 Respuesta recibida del servidor:", response);

                if (!response.ok) {
                    let errorMessage = await response.text();
                    throw new Error("Error en el servidor: " + errorMessage);
                }

                let data = await response.json();
                console.log("📥 JSON del servidor:", data);

                if (!data.image_url) {
                    throw new Error("❌ No valid URL received from the server.");
                }

                console.log("✅ Imagen SVG guardada en el servidor:", data.image_url);

                // 🧼 Limpiar localstorage procesos anteriores
                localStorage.removeItem("hasOriginalImage");
                localStorage.removeItem("hasOriginalDraw");
                localStorage.removeItem("customColorDataURL"); // 🔸 Limpia el archivo .txt anterior

                // 🔹 Guardar nuevas URLs
                localStorage.setItem("customImageURL", data.image_url);
                if (data.image_url) {
                    const txtUrl = data.image_url.replace(".svg", ".txt");
                    localStorage.setItem("customColorDataURL", txtUrl);
                }
                localStorage.setItem("hasOriginalMold", "true");
                localStorage.setItem("hasClassicMold", "true");

                hideLoading();

                // 🔹 Redirigir a la colección
                window.location.href = "/pages/select-your-base";

            } catch (error) {
                hideLoading();
                console.error("❌ Error en el proceso:", error);
                alert("❌ Error saving the SVG image. Please try again.\n\nDetails: " + error.message);
            }
        });
    } else {
        console.warn("⚠️ El botón selectBaseButton no está en el DOM todavía.");
    }
});